import gql from 'graphql-tag';

export const getStudentPortalSettings = gql`
  query getStudentPortalSettings {
    serviceInformation {
      config
    }
  }
`;

export const getBannerList = gql`
  query getBannerList {
    externalSettings {
      bannerList {
        id
        urlRef
        image
        imageUrl
      }
    }
  }
`;

export const bannerDetail = gql`
  query bannerDetail($bannerId: Float!) {
    externalSettings {
      bannerDetail(bannerId: $bannerId) {
        id
        urlRef
        image
      }
    }
  }
`;

export const getLinksInterest = gql`
  query getLinksInterest {
    startApp {
      linksInterest {
        name
        link
      }
    }
  }
`;

export const getVersion = gql`
  query getLastVersion {
    lastVersion {
      version
      buildTime
    }
  }
`;
